import React from 'react';

interface StoryProgressProps {
  total: number;
  current: number;
  progress: number;
}

const StoryProgress: React.FC<StoryProgressProps> = ({ total, current, progress }) => (
  <div className="story-progress">
    {Array.from({ length: total }).map((_, i) => {
      const fill = i < current ? 1 : i === current ? progress : 0;
      return (
        <div key={i} className="story-progress__segment">
          <div
            className="story-progress__fill"
            style={{ width: `${fill * 100}%` }}
          />
        </div>
      );
    })}
  </div>
);

export default StoryProgress;
